import { debounce } from './utilities';
/**
 * Fixes height of image on hero when there is additional text
 */
let heros = document.querySelectorAll('[data-behaviour="set-image-height"]');
heros.forEach(wrap => {
	let imageWrap = wrap.querySelector('[data-ref="desktop-image"]');
	const tabletBP = 768;
	if (imageWrap) {
		window.addEventListener('load', () => {
			let container = wrap.querySelector('[data-ref="container"]');
			let paddingTop = parseInt(window.getComputedStyle(wrap, null).getPropertyValue('padding-top'));  
			let heightToSet = container.offsetHeight;

			let image = imageWrap.querySelector('img');
			if (image && image.style) {
				image.style.height = (heightToSet + paddingTop) + 'px';
			}
		})

		window.addEventListener('resize', debounce( () => {
			if (document.body.clientWidth > tabletBP) {
				let container = wrap.querySelector('[data-ref="container"]');
				let paddingTop = parseInt(window.getComputedStyle(wrap, null).getPropertyValue('padding-top'));  
				let heightToSet = container.offsetHeight;

				let image = imageWrap.querySelector('img');
				if (image && image.style) {
					image.style.height = (heightToSet + paddingTop) + 'px';
				}
			}
		}, 300));
	}
});